var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconZipCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(-0.267)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0.267)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M19.385,8.308H11.077v2.769h8.308V21.231H2.769V11.077H5.538v5.538H8.308V5.538h8.308V0H5.538V8.308H2.769A2.777,2.777,0,0,0,0,11.077V21.231A2.777,2.777,0,0,0,2.769,24H19.385a2.777,2.777,0,0,0,2.769-2.769V11.077A2.777,2.777,0,0,0,19.385,8.308Z",
    transform: "translate(1 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZipCode);
export default __webpack_public_path__ + "static/media/icon-zip-code.eaae7a4fe9cf08f8aedacc56f81039da.svg";
export { ForwardRef as ReactComponent };